<template>
    <div>
        <!-- 添加分销产品弹框 -->
        <compFormEdit class="margin-top-15 margin-right-15" :formdata="getBase" v-model="formData" :labelWidth="120"></compFormEdit>
        <div>
            <vButton theme="primary">保存</vButton>
            <vButton>取消</vButton>
        </div>
    </div>
</template>

<script>
import { mapState} from 'vuex'

export default {
    data(){
        return {
            
        }
    },
    computed:{
        ...mapState('boss', ['products']),
        getBase(){
            return [
                {
					label: "原ERPSKU",
					key: "orderNo",
					required: false,
					query: this.showquery,
					children: (h) => {
						return <vIcon 
							title="搜索品类"
							type="search"
							center
							slot="suffix"
							style="padding:6px;pointer-events: initial;"
							size="18"
							nativeOnClick={this.handleModalplat.bind(this)}
						/>
					},
					props: {
                        // readonly: true,
                        placeholder:"自动生成管理码"
					}
                },
                {
					label: "分销ERPSKU",
					key: "orderEmail",
					tag: "vInput",
					required: false,
					query: this.showquery,
                },
                {
					label: "项目",
					key: "lineId",
					tag: "vSelect",
					query: this.showquery,
					options: this.products.map((item) => {
						return {
							value: item.id,
							label: item.name
						}
					}),
					props: {
						filterable: true,
					}
                },
                {
					label: "分销价格(USD)",
					key: "orderEmail",
					tag: "vInput",
					required: false,
                    query: this.showquery,
                    formItem:{
                        tip:'<div class="color-error">(供应商提供的分销价格)</div>'
                    }
                },
            ]
        }
    },
    methods:{
        handleModalplat(){

        }
    }
}
</script>